import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import WeightIcon from "../../assets/UserPanelAssets/img/icons/weight.svg";
import HeightIcon from "../../assets/UserPanelAssets/img/icons/rotate-left.svg";
import BmiIcon from "../../assets/UserPanelAssets/img/icons/user-cirlce-add.svg";
import PulseIcon from "../../assets/UserPanelAssets/img/icons/driver-2.svg";
import Spo2Icon from "../../assets/UserPanelAssets/img/icons/wind.svg";
import TemperatureIcon from "../../assets/UserPanelAssets/img/icons/sun.svg";

// Doctor Images (replace with your correct paths)
import doc1 from "../../assets/UserPanelAssets/img/doctors/doctor-01.jpg";
import doc2 from "../../assets/UserPanelAssets/img/doctors/doctor-02.jpg";
import doc3 from "../../assets/UserPanelAssets/img/doctors/doctor-03.jpg";
import doc4 from "../../assets/UserPanelAssets/img/doctors/doctor-04.jpg";
import doc5 from "../../assets/UserPanelAssets/img/doctors/doctor-05.jpg";

import Doc1 from "../../assets/UserPanelAssets/img/doctors/doctor-06.jpg";

export default function index() {
  return (
    <div className="content pb-0" data-aos="fade-up">
      {/* Page Header */}
      <div
        className="d-flex align-items-sm-center justify-content-between flex-wrap gap-2 mb-4"
        data-aos="fade-down"
      >
        <div>
          <h4 className="fw-bold mb-0">Patient Dashboard</h4>
        </div>

        <div className="d-flex align-items-center flex-wrap gap-2">
          <button
            className="btn btn-primary d-inline-flex align-items-center"
            data-bs-toggle="offcanvas"
            data-bs-target="#new_appointment"
          >
            <i className="ti ti-plus me-1"></i>
            New Appointment
          </button>
        </div>
      </div>
      {/* End Page Header */}

      {/* row start */}
      <div className="row" data-aos="fade-up">
        {/* card 1 */}
        <div className="col-xl-3 col-md-6 d-flex">
          <div className="card flex-fill w-100 shadow-sm">
            <div className="card-body">
              <div className="d-flex align-items-center mb-4">
                <span className="avatar bg-primary rounded-circle fs-20 d-inline-flex flex-shrink-0">
                  <i className="ti ti-calendar-heart"></i>
                </span>
                <div className="ms-2">
                  <p className="mb-1 text-truncate">Total Appointments</p>
                  <h3 className="fw-bold mb-0">24</h3>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <span className="badge fw-medium bg-success flex-shrink-0 me-2">
                  +95%
                </span>
                <p className="fs-13 mb-0">in last 7 Days</p>
              </div>
            </div>
          </div>
        </div>

        {/* card 2 */}
        <div className="col-xl-3 col-md-6 d-flex">
          <div className="card flex-fill w-100 shadow-sm">
            <div className="card-body">
              <div className="d-flex align-items-center mb-4">
                <span className="avatar bg-danger rounded-circle fs-20 d-inline-flex flex-shrink-0">
                  <i className="ti ti-users"></i>
                </span>
                <div className="ms-2">
                  <p className="mb-1 text-truncate">Online Consultations</p>
                  <h3 className="fw-bold mb-0">36</h3>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <span className="badge fw-medium bg-danger flex-shrink-0 me-2">
                  -15%
                </span>
                <p className="fs-13 mb-0">in last 7 Days</p>
              </div>
            </div>
          </div>
        </div>

        {/* card 3 */}
        <div className="col-xl-3 col-md-6 d-flex">
          <div className="card flex-fill w-100 shadow-sm">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <p className="mb-1 text-truncate">Blood Pressure</p>
                  <span className="badge fw-medium bg-success me-2">+95%</span>
                </div>
                <div className="d-flex align-items-center">
                  <h3 className="fw-bold mb-0 me-1">89</h3>
                  <p className="mb-0">g/dl</p>
                </div>
              </div>
              <div id="s-col-8" className="chart-set"></div>
            </div>
          </div>
        </div>

        {/* card 4 */}
        <div className="col-xl-3 col-md-6 d-flex">
          <div className="card flex-fill w-100 shadow-sm">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <p className="mb-1 text-truncate">Heart Rate</p>
                  <span className="badge fw-medium bg-success me-2">+95%</span>
                </div>
                <div className="d-flex align-items-center">
                  <h3 className="fw-bold mb-0 me-1">87</h3>
                  <p className="mb-0">bpm</p>
                </div>
              </div>
              <div id="s-col-9" className="chart-set"></div>
            </div>
          </div>
        </div>
      </div>

      {/* row start */}
      <div className="row" data-aos="fade-up">
        {/* My Doctors */}
        <div className="col-xl-4 col-lg-6 d-flex">
          <div className="card shadow-sm flex-fill w-100">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0">My Doctors</h5>
            </div>

            <div className="card-body">
              {/* doctor row */}
              {[
                {
                  img: doc1,
                  name: "Dr. Mick Thompson",
                  spec: "Cardiologist",
                  book: "20 Bookings",
                },
                {
                  img: doc2,
                  name: "Dr. Sarah Johnson",
                  spec: "Orthopedic Surgeon",
                  book: "15 Bookings",
                },
                {
                  img: doc3,
                  name: "Dr. Emily Carter",
                  spec: "Pediatrician",
                  book: "12 Bookings",
                },
                {
                  img: doc4,
                  name: "Dr. David Lee",
                  spec: "Gynecologist",
                  book: "8 Bookings",
                },
                {
                  img: doc5,
                  name: "Dr. Anna Kim",
                  spec: "Psychiatrist",
                  book: "6 Bookings",
                },
              ].map((d, i) => (
                <div
                  key={i}
                  className={`d-flex align-items-center justify-content-between ${
                    i < 4 ? "mb-3" : "mb-0"
                  }`}
                >
                  <div className="d-flex align-items-center">
                    <button className="avatar me-2 flex-shrink-0 p-0 bg-transparent border-0">
                      <img
                        src={d.img}
                        alt="doctor"
                        className="rounded-circle"
                      />
                    </button>

                    <div>
                      <h6 className="fs-14 mb-1 text-truncate fw-semibold">
                        {d.name}
                      </h6>
                      <p className="mb-0 fs-13 text-truncate">{d.spec}</p>
                    </div>
                  </div>

                  <span className="badge fw-medium badge-soft-danger border border-danger flex-shrink-0">
                    {d.book}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Prescriptions (partial converted because your paste cut off) */}
        <div className="col-xl-4 col-lg-6 d-flex">
          <div className="card shadow-sm flex-fill w-100">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0">Prescriptions</h5>
            </div>
            <div className="card-body">
              <div className="overflow-auto">
                {/* Example card */}
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center flex-shrink-0">
                    <div className="avatar me-2 bg-light rounded-circle text-dark p-2">
                      <i className="ti ti-file-description text-body fs-20"></i>
                    </div>

                    <div>
                      <h6 className="fs-14 mb-1 fw-semibold text-truncate">
                        Cardiology Prescription
                      </h6>
                      <p className="mb-0 fs-13 text-truncate">20 Apr 2025</p>
                    </div>
                  </div>

                  <div className="d-flex align-items-center">
                    <button className="btn btn-outline-white shadow-sm me-2 p-1">
                      <i className="ti ti-eye"></i>
                    </button>
                    <button className="btn btn-outline-white shadow-sm p-1">
                      <i className="ti ti-download"></i>
                    </button>
                  </div>
                </div>

                {/* Continue with the rest if you paste more */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* card start */}
      <div className="card shadow-sm">
        <div className="card-header">
          <h5 className="fw-bold mb-0">Vitals</h5>
        </div>

        <div className="card-body">
          {/* row start */}
          <div className="row row-gap-3 row-cols-1 row-cols-xl-6 row-cols-md-3 row-cols-sm-2">
            {/* Weight */}
            <div className="col d-flex">
              <div className="p-3 border shadow-sm flex-fill w-100 rounded-2">
                <div className="d-flex align-items-center">
                  <span className="avatar bg-primary rounded-circle flex-shrink-0">
                    <img src={WeightIcon} alt="img" className="w-auto h-auto" />
                  </span>
                  <div className="ms-1">
                    <p className="mb-1">Weight</p>
                    <p className="text-truncate">
                      <span className="fs-18 fw-bold text-dark">100</span> Kg
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Height */}
            <div className="col d-flex">
              <div className="p-3 border shadow-sm flex-fill w-100 rounded-2">
                <div className="d-flex align-items-center">
                  <span className="avatar bg-primary rounded-circle flex-shrink-0">
                    <img src={HeightIcon} alt="img" className="w-auto h-auto" />
                  </span>
                  <div className="ms-1">
                    <p className="mb-1">Height</p>
                    <p className="text-truncate">
                      <span className="fs-18 fw-bold text-dark">154</span> Cm
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* BMI */}
            <div className="col d-flex">
              <div className="p-3 border shadow-sm flex-fill w-100 rounded-2">
                <div className="d-flex align-items-center">
                  <span className="avatar bg-primary rounded-circle flex-shrink-0">
                    <img src={BmiIcon} alt="img" className="w-auto h-auto" />
                  </span>
                  <div className="ms-1">
                    <p className="mb-1">BMI</p>
                    <p className="text-truncate">
                      <span className="fs-18 fw-bold text-dark">19.2</span>{" "}
                      kg/cm
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Pulse */}
            <div className="col d-flex">
              <div className="p-3 border shadow-sm flex-fill w-100 rounded-2">
                <div className="d-flex align-items-center">
                  <span className="avatar bg-primary rounded-circle flex-shrink-0">
                    <img src={PulseIcon} alt="img" className="w-auto h-auto" />
                  </span>
                  <div className="ms-1">
                    <p className="mb-1">Pulse</p>
                    <p className="text-truncate">
                      <span className="fs-18 fw-bold text-dark">97%</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* SPO2 */}
            <div className="col d-flex">
              <div className="p-3 border shadow-sm flex-fill w-100 rounded-2">
                <div className="d-flex align-items-center">
                  <span className="avatar bg-primary rounded-circle flex-shrink-0">
                    <img src={Spo2Icon} alt="img" className="w-auto h-auto" />
                  </span>
                  <div className="ms-1">
                    <p className="mb-1">SPO2</p>
                    <p className="text-truncate">
                      <span className="fs-18 fw-bold text-dark">98%</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Temperature */}
            <div className="col d-flex">
              <div className="p-3 border shadow-sm flex-fill w-100 rounded-2">
                <div className="d-flex align-items-center">
                  <span className="avatar bg-primary rounded-circle flex-shrink-0">
                    <img
                      src={TemperatureIcon}
                      alt="img"
                      className="w-auto h-auto"
                    />
                  </span>
                  <div className="ms-1">
                    <p className="mb-1 text-truncate">Temperature</p>
                    <p className="text-truncate">
                      <span className="fs-18 fw-bold text-dark">101</span> C
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* row end */}
        </div>
      </div>
      {/* card end */}

      {/* row start */}
      <div className="row">
        {/* Consultation Chart */}
        <div className="col-lg-6 d-flex">
          <div className="card shadow-sm flex-fill w-100">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0">Consultation By Department</h5>
              <div className="dropdown">
                <button
                  className="btn btn-sm px-2 border shadow-sm btn-outline-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Monthly <i className="ti ti-chevron-down ms-1"></i>
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <button className="dropdown-item">Monthly</button>
                  </li>
                  <li>
                    <button className="dropdown-item">Weekly</button>
                  </li>
                  <li>
                    <button className="dropdown-item">Yearly</button>
                  </li>
                </ul>
              </div>
            </div>

            <div className="card-body pb-0">
              <div id="s-col-10" className="chart-set"></div>
            </div>
          </div>
        </div>

        {/* Transactions Table */}
        <div className="col-lg-6 d-flex">
          <div className="card shadow-sm flex-fill w-100">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0">Recent Transactions</h5>
              <div className="dropdown">
                <button
                  className="btn btn-sm px-2 border shadow-sm btn-outline-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Weekly <i className="ti ti-chevron-down ms-1"></i>
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <button className="dropdown-item">Monthly</button>
                  </li>
                  <li>
                    <button className="dropdown-item">Weekly</button>
                  </li>
                  <li>
                    <button className="dropdown-item">Yearly</button>
                  </li>
                </ul>
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive table-nowrap">
                <table className="table">
                  <tbody>
                    <tr className="border">
                      <td className="ps-0">
                        <div className="d-flex align-items-center">
                          <span className="avatar me-2">
                            <img
                              src={Doc1}
                              alt="img"
                              className="rounded-circle"
                            />
                          </span>
                          <div>
                            <h6 className="fs-14 mb-1">
                              <a className="fw-semibold">Dr. John Smith</a>
                            </h6>
                            <p className="mb-0 fs-13">Neurosurgeon</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <h6 className="fs-14 fw-semibold">Consultation Fees</h6>
                        <p className="fs-13">$450</p>
                      </td>
                      <td className="pe-0 text-end">
                        <span className="badge fs-13 py-1 badge-soft-success border border-success rounded text-success fw-medium">
                          Success
                        </span>
                      </td>
                    </tr>

                    {/* Add other rows the same way */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* row end */}
    </div>
  );
}
